import React from 'react'

type BuilderData = {
  onBeforeAction(): void
  onActionSuccess(reFetch?: boolean): void
  onActionError(err: Error): void
}

export const BuilderContext = React.createContext<BuilderData>({
  onBeforeAction: () => {},
  onActionSuccess: () => {},
  onActionError: (_: Error) => {},
})
